/* Shipping-protection line handling.

   The protection product (handle: kaching-cart-toggle) is already presented
   to the shopper as the toggle row at the bottom of the drawer, with its own
   $3.95 label. Repeating it as a normal cart line - image, quantity stepper,
   delete button - is duplicate UI and lets the shopper remove it by a route
   that leaves the toggle showing ON.

   So inside the CART DRAWER we hide that line. The charge stays fully
   disclosed: the toggle row shows the price and the drawer total includes it.

   Deliberately drawer-only. On /cart there is no toggle, so hiding the line
   there would leave a $3.95 charge with nothing explaining it.

   Primary hiding is CSS :has() in cart-drawer-custom.css (no flicker). This
   script is the fallback for browsers without :has(), plus the busy state on
   the toggle - the add/remove round trip is ~760ms on a fast connection and
   2-3s on mobile data, which otherwise looks like nothing happened. */
(function () {
  if (window.__shipProtectFeedbackBound) return;
  window.__shipProtectFeedbackBound = true;

  var PROTECT_HANDLE = 'kaching-cart-toggle';
  var pendingTimer = null;

  /* Fallback for browsers without :has() support. */
  function hideProtectLine() {
    var rows = document.querySelectorAll('cart-drawer .cart-item');
    for (var i = 0; i < rows.length; i++) {
      var link = rows[i].querySelector('a[href*="' + PROTECT_HANDLE + '"]');
      if (link && !rows[i].classList.contains('sp-line-hidden')) {
        rows[i].classList.add('sp-line-hidden');
      }
    }
  }

  document.addEventListener('change', function (e) {
    var toggle = e.target && e.target.closest && e.target.closest('[data-ship-protect-toggle]');
    if (!toggle) return;
    var wrap = toggle.closest('[data-ship-protect]');
    if (!wrap) return;
    wrap.classList.add('sp-pending');
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () {
      wrap.classList.remove('sp-pending');
    }, 12000);
  });

  function afterRender() {
    hideProtectLine();
    var wrap = document.querySelector('[data-ship-protect]');
    if (wrap) wrap.classList.remove('sp-pending');
    clearTimeout(pendingTimer);
  }

  function watch() {
    var host = document.getElementById('CartDrawer');
    if (!host) return false;
    new MutationObserver(function () { afterRender(); })
      .observe(host, { childList: true, subtree: true });
    hideProtectLine();
    return true;
  }

  function init() {
    if (watch()) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (watch() || ++tries > 40) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
